import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { box, pageSubtitle } from '@/ui/components';
import { canUpgrade } from '@/ui/auth/auth';
import { upgradeOrSubscribeButton } from '@/ui/components/upgrade/UpgradeOrSubscribeButton';
import { TeaserRoutes } from '@/ui/routes/types';

interface ResourceTeaserPageProps {
  title: string;
  message?: string;
  subtitle: string;
  routeName?: string;
}

export const ResourceTeaserPage = defineComponent<ResourceTeaserPageProps>({
  name: 'ResourceTeaserPage',
  props: ['title', 'message', 'subtitle', 'routeName'],
  setup(props) {
    return function render() {
      return box([
        h('img', { attrs: { src: '/images/star.svg', class: 'teaser__star' } }),
        pageSubtitle(props.subtitle, 'teaser__subtitle'),
        h('div', { class: 'teaser__message' }, props.message ? props.message : t('common.teaser')),
        h('div', {
          class: 'teaser__button',
        }, [
          canUpgrade()
            ? upgradeOrSubscribeButton({}, { target: `resource-teaser--${props.routeName}` })
            : null,
        ]),
      ], { class: 'teaser is-max-desktop' });
    };
  },
});

export const renderResourceTeaserPage = (
  title: string,
  message?: string,
  subtitle?: string,
  routeName?: TeaserRoutes,
) => () => h(ResourceTeaserPage, {
  props: {
    title,
    message,
    subtitle,
    routeName,
  },
});
